import { render, staticRenderFns } from "./UpdatePriceDialog.vue?vue&type=template&id=1976d70f&scoped=true&"
import script from "./UpdatePriceDialog.vue?vue&type=script&lang=js&"
export * from "./UpdatePriceDialog.vue?vue&type=script&lang=js&"
import style0 from "./UpdatePriceDialog.vue?vue&type=style&index=0&id=1976d70f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1976d70f",
  null
  
)

export default component.exports